<template>
  <layout kind="one_column">
    <v-container fluid>
      <v-flex xs12 mb-3>
        <h1 class="max">Transferências Pix Genial</h1>
      </v-flex>
      <v-layout row wrap class="transactions-filter" pt-4 px-3>
        <v-flex md4>
          <DefaultFilterDate
            ref="filterDate"
            @reload="this.reloadDate"
            kind="date"
          />
        </v-flex>
        <v-flex xs6 md2 px-1>
          <v-btn class="filter-btn"
            color="#27DABC" 
            depressed dark 
            :disabled="disableAddButton"
            @click="addDateToList()">Adicionar ao monitor</v-btn>
        </v-flex>
        <v-flex xs6 md2 px-1>
          <v-btn class="filter-btn"
            color="#E06464"
            depressed dark
            @click="disconnectSocket()">Fechar a conexão</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md4 px-1 py-2 v-for="(date, index) in datesList" :key="date">
          <PixWiresTotals
            :pickedDate="date"
            @onRemove="removeDateFromList"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
  import utils from "../shared/Utils";
  import LeftBarLayout from "../layouts/LeftBarLayout"
  import PixWiresTotals from "../components/PixWiresTotals.vue"
  import DefaultFilterDate from "../components/filters/DefaultFilterDate"

  export default {
    name: 'PixWiresPage',
    components: {
      layout: LeftBarLayout,
      PixWiresTotals,
      DefaultFilterDate
    },
    data() {
      return {
        selectedDate: null,
        datesList: []
      }
    },
    methods: {
      reloadDate(filter_date) {
        this.selectedDate = filter_date
      },
      addDateToList() {
        if (this.datesList.findIndex(el => el === this.selectedDate) === -1) {
          this.datesList.push(this.selectedDate)
        }
      },
      removeDateFromList(record) {
        this.datesList.splice(this.datesList.findIndex(el => el === record), 1)
      },
      disconnectSocket() {
        this.$root.store.disconnectSocket()
      }
    },
    computed: {
      disableAddButton() {
        return this.datesList.findIndex(el => el === this.selectedDate) > 0 &&
        this.datesList.length > 0
      },
    },
    mounted() {
      this.selectedDate = utils.currentDate()
      this.$refs.filterDate.filterDate = utils.currentDate()
      this.$root.authenticationStore.redirectIfNotAuthenticated()
      this.$root.store.connectSocket(this.$cookies.get('api_token'))
    },
    metaInfo: {
      title: "Facilita Pay"
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/PixWiresPage.vue